"use client";

import React from 'react';
import { Form, Input, Button, Select } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../redux/store';
import { updateProject } from '../../../redux/features/userProject/userProjectSlice';

interface ProjectFormProps {
  next: () => void;
  prev: () => void;
}

export default function ProjectForm({ next, prev }: ProjectFormProps) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const projects = useSelector((state: RootState) => state.userProject.projects);
  const currentProject = projects.length > 0 ? projects[0] : null;

  const handleFinish = (values: any) => {
    if (!currentProject) return;
    dispatch(updateProject({
      buyerPurchaseId: currentProject.buyerPurchaseId,
      updatedProject: {
        buyerPurchasePrice: values.price,
        buyerPurchaseCurrency: values.currency,
        buyerLocation: values.location,
        buyerFirstName: values.firstName,
        buyerLastName: values.lastName,
        buyerEmailAdress: values.email,
        projectStepKey: 'form',
        projectStepAlt: 'filling-form',
        projectStepLabel: 'Fill Form'
      }
    }));
    next();
  };

  return (
    <div>
      <h2>Fill in your information</h2>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{
          currency: 'ETH',
        }}
      >
        <Form.Item
          label="First Name"
          name="firstName"
          rules={[{ required: true, message: 'Please input your First Name' }]}
        >
          <Input placeholder="John" />
        </Form.Item>

        <Form.Item
          label="Last Name"
          name="lastName"
          rules={[{ required: true, message: 'Please input your Last Name' }]}
        >
          <Input placeholder="Doe" />
        </Form.Item>

        <Form.Item
          label="Email Address"
          name="email"
          rules={[{ required: true, type: 'email', message: 'Please input a valid Email' }]}
        >
          <Input placeholder="john.doe@example.com" />
        </Form.Item>

        <Form.Item
          label="Location"
          name="location"
          rules={[{ required: true, message: 'Please input your location' }]}
        >
          <Input placeholder="Paris, France" />
        </Form.Item>

        <Form.Item
          label="Purchase Price"
          name="price"
          rules={[{ required: true, message: 'Please input the purchase price' }]}
        >
          <Input type="number" placeholder="100" />
        </Form.Item>

        <Form.Item
          label="Currency"
          name="currency"
          rules={[{ required: true, message: 'Please select a currency' }]}
        >
          <Select>
            <Select.Option value="ETH">ETH</Select.Option>
            <Select.Option value="€">€</Select.Option>
          </Select>
        </Form.Item>

        <div style={{ marginTop: 20 }}>
          <Button onClick={prev} style={{ marginRight: 10 }}>Back</Button>
          <Button type="primary" htmlType="submit">Next</Button>
        </div>
      </Form>
    </div>
  );
}
